import React from 'react'
import { Link } from 'react-router-dom'
import './artists.css'

const Footer = ({ user, loginClick }) => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="siteModernFooter">
      <div className="container">
        <div className="siteFooterContent">
          <div className="siteFooterBrand">
            <span className="siteFooterLogo">Dionyziuz</span>
            <span className="siteFooterTagline">Specialized AI for the things you love</span>
          </div>

          <nav className="siteFooterLinks" aria-label="Footer navigation">
            <a href="#apps" className="siteFooterLink">Agents</a>
            <Link to="/wind" className="siteFooterLink">Windsports</Link>
            <Link to="/sierra" className="siteFooterLink">Sierra Guide</Link>
            <Link to="/media" className="siteFooterLink">Movies &amp; Series</Link>
            <Link to="/tichess" className="siteFooterLink">TiChess</Link>
            <Link to="/transformation" className="siteFooterLink">Art Studio</Link>
            <a href="#mission" className="siteFooterLink">Mission</a>
            <a href="#artists" className="siteFooterLink">Artists</a>
            <Link to="/contact-us" className="siteFooterLink">Contact</Link>
            <Link to="/tos" className="siteFooterLink">Terms</Link>
          </nav>
        </div>

        <div className="siteFooterCopy">
          <span>&copy; {currentYear} Dionyziuz. All rights reserved.</span>
          <Link to="/tos" className="siteFooterLegal">Terms of Service</Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
